// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3DsWw","option":"styles_option__1AuRl","selected":"styles_selected__1fz8Z"};